import React from 'react';

import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import type { AlertProps } from '@mui/material/Alert';
import { blue20, blue50, blue90, red20, red50, red90 } from '../../constants/colors';

const styles = {
  alertBg: {
    '& .MuiAlert-icon': {
      color: red50,
      display: 'flex',
      alignItems: 'center',
    },
    backgroundColor: red20,
    border: `1px solid ${red50}`,
    color: red90,
    fontSize: '14px',
    whiteSpace: 'break-spaces',
    textAlign: 'left',
  },
  infoBg: {
    '& .MuiAlert-icon': {
      color: blue50,
      display: 'flex',
      alignItems: 'center',
    },
    backgroundColor: blue20,
    border: `1px solid ${blue50}`,
    color: blue90,
    fontSize: '14px',
    textAlign: 'left',
  },
};

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert sx={styles.alertBg} ref={ref} {...props} />
));

Alert.displayName = 'Alert';

const Info = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert sx={styles.infoBg} ref={ref} {...props} />
));

Info.displayName = 'Info';

type SnackbarProps = React.ComponentProps<typeof Snackbar>;

type Props = SnackbarProps & {
  text: string;
  infoText?: string | undefined | null;
  closeButton?: () => void;
};

const CustomSnackbar: React.FC<Props> = props => {
  const { text, infoText, closeButton, ...rest } = props;

  return (
    <>
      {text && (
        <Snackbar {...rest}>
          <Alert severity="error" {...(closeButton && { onClose: closeButton })}>
            {text}
          </Alert>
        </Snackbar>
      )}
      {infoText && (
        <Snackbar {...rest}>
          <Info severity="info" {...(closeButton && { onClose: closeButton })}>
            {infoText}
          </Info>
        </Snackbar>
      )}
    </>
  );
};

export default CustomSnackbar;
